import React, {useState} from "react";
import {Product} from "@/data/entities/menu";
import {productPlaceholderImgSrc} from "@/data/entities/product";
import {twJoin} from "tailwind-merge";

type Props = {
    product: Product,
};

const ProductNameFormatter = ({product}: Props) => {
    const [loadingImage, setLoadingImage] = useState(true);
    const [imgSrc, setImgSrc] = useState(product.images.length > 0 ? product.images[0] : productPlaceholderImgSrc);

    return (
        <div className={"w-[200px] md:w-[400px] flex flex-row items-center justify-start gap-4"}>
            <img
                alt={product.name}
                width={"70"}
                height={"70"}
                className={twJoin(
                    "w-[50px] h-[50px] md:w-[70px] md:h-[70px] object-cover rounded-xl shrink-0 grow-0 bg-black/10 dark:bg-white/10",
                    loadingImage ? "animate-pulse" : "",
                )}
                src={imgSrc}
                onError={() => {
                    setLoadingImage(false);
                    setImgSrc(productPlaceholderImgSrc)
                }}
                onLoad={() => setLoadingImage(false)}
            />
            <h3 className={"font-medium md:text-base"}>
                {product.name}
            </h3>
        </div>
    );
};

export default ProductNameFormatter;